import { createResource, createSignal, For, Match, on, onCleanup, onMount, Show, Switch } from "solid-js";

import socket from "./socket";
import AdminUsers from "./AdminUsers";
import { useAdminContext } from "./AdminContext";
import { useUserContext } from "./UserContext";
import { NavDropdown } from "./Components";
import AdminPromos from "./AdminPromos";
import AdminConventions from "./AdminConventions";
import AdminEmailTemplates from "./AdminEmailTemplates";
import AdminNotifications from "./AdminNotifications";
import AdminYears from "./AdminYears";
import AdminConventionStructure from "./AdminConventionStructure";
import { useI18n } from "./i18n";

export default function Admin() {

  const [adminStore, setAdminStore] = useAdminContext();
  const [userStore, setUserStore] = useUserContext();

  const [activeTab, setActiveTab] = createSignal('Liste Etudiants');

  const tabClass = (tabName) => {
    return activeTab() === tabName ? 'nav-link active' : 'nav-link';
  }
  const handleTabClick = (tabName) => (event) => {
    setActiveTab(tabName);
    event.preventDefault();
  };

  return <>
    <Switch>
      <Match when={userStore.page === '/manage-users'}>
        <AdminUsers />
      </Match>
      <Match when={userStore.page === '/manage-promos'}>
        <AdminPromos />
      </Match>
      <Match when={userStore.page === '/manage-email-templates'}>
        <AdminEmailTemplates />
      </Match>
      <Match when={userStore.page === '/manage-notifications'}>
        <AdminNotifications />
      </Match>
      <Match when={userStore.page === '/manage-years'}>
        <AdminYears />
      </Match>
      <Match when={userStore.page === '/manage-convention-structure'}>
        <AdminConventionStructure />
      </Match>
      <Match when={userStore.page === '/'}>
        <AdminConventions />
      </Match>
    </Switch>
  </>
}

export const AdminMenu = () => {

  const t = useI18n();
  const [userStore, setUserStore, userActions] = useUserContext();

  return <NavDropdown label={t("Admin")}>
    <li><a
      onclick={(e) => { e.preventDefault(); userActions.setPage('/manage-users'); }}
      class="dropdown-item" href="/manage-users">{t("Manage Users")}</a></li>
    <li><a
      onclick={(e) => { e.preventDefault(); userActions.setPage('/manage-promos'); }}
      class="dropdown-item" href="/manage-promos">{t("Manage Promos")}</a></li>
    <li><a
      onclick={(e) => { e.preventDefault(); userActions.setPage('/manage-years'); }}
      class="dropdown-item" href="/manage-years">{t("Manage Years")}</a></li>
    <li><a
      onclick={(e) => { e.preventDefault(); userActions.setPage('/manage-convention-structure'); }}
      class="dropdown-item" href="/manage-convention-structure">{t("Form Structure")}</a></li>
    <li><a
      onclick={(e) => { e.preventDefault(); userActions.setPage('/manage-email-templates'); }}
      class="dropdown-item" href="/manage-email-templates">{t("Email Templates")}</a></li>
    <li><a
      onclick={(e) => { e.preventDefault(); userActions.setPage('/manage-notifications'); }}
      class="dropdown-item" href="/manage-notifications">{t("Notification Log")}</a></li>
  </NavDropdown>;
}
